module.exports = __webpack_public_path__ + "img/doctor_step2.26081b6e.png";